import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';

@Pipe({
    name: 'chipTooltip',
    standalone: false
})
export class ChipTooltipPipe implements PipeTransform {

    constructor(public localizationService: LocalizationService) { }

    /**
     * Creates html markup for a pTooltip with an optional label and styled chips. Note: must set [escape]=false
     * @param chips string values for the chips
     * @param label optional text that preceeds chips
     * @returns tooltip inner HTML
     */
    transform(chips: string[], label?: string): string {
        let tooltip;
        if (!chips) {
            return tooltip;
        } else {
            tooltip = `<div class="agpr-chipTooltip">${this.localizationService.transform(label)}<div class="agpr-chipTooltip-container">`;
            chips.forEach(chip => {
                tooltip += `<div class="agpr-chipTooltip-chip"><span>${this.localizationService.transform(chip)}</span></div>`;
            });
            tooltip += '</div></div>';
        }
        return tooltip;
    }
}
